export default "__VITE_ASSET__D0JO8Z3W__"